import { render, staticRenderFns } from "./DepositDialog.vue?vue&type=template&id=03bd626e&scoped=true"
import script from "./DepositDialog.vue?vue&type=script&lang=js"
export * from "./DepositDialog.vue?vue&type=script&lang=js"
import style0 from "./DepositDialog.vue?vue&type=style&index=0&id=03bd626e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bd626e",
  null
  
)

export default component.exports